class FreeShippingMeter extends HTMLElement {
  constructor() {
    super();
  }

  static texts = window.free_shipping_text || {};
  static freeShippingText = FreeShippingMeter.texts.free_shipping_message;
  static freeShippingText1 = FreeShippingMeter.texts.free_shipping_message_1;
  static freeShippingText2 = FreeShippingMeter.texts.free_shipping_message_2;
  static freeShippingText3 = FreeShippingMeter.texts.free_shipping_message_3;
  static freeShippingText4 = FreeShippingMeter.texts.free_shipping_message_4;
  static classLabel1 = "progress-30";
  static classLabel2 = "progress-60";
  static classLabel3 = "progress-100";
  static freeshipPrice = parseInt(window.free_shipping_price);
  static pedidoEmVoo = null;

  connectedCallback() {
    this.freeShippingEligible = 0;
    this.progressBar = this.querySelector("[data-shipping-progress]");
    this.messageElement = this.querySelector("[data-shipping-message]");
    this.textEnabled = this.progressBar?.dataset.textEnabled === "true";
    this.shipVal = FreeShippingMeter.texts.free_shipping_1;
    this.progressMeter = this.querySelector(
      "[data-free-shipping-progress-meter]"
    );

    // Marcos (Configuracoes do tema > Mensagens de frete gratis). Vazio = modo antigo.
    this.marcos = this.readMarcos();
    this.wonElement = this.querySelector("[data-fsbar-won]");
    this.marksElement = this.querySelector("[data-fsbar-marks]");
    if (this.marcos.length) {
      this.renderMarks();
      this.observarLargura();
    }

    this.addEventListener("change", this.onCartChange.bind(this));

    this.initialize();
  }

  disconnectedCallback() {
    this.observador?.disconnect();
  }

  // O trilho muda de largura ao girar o celular ou redimensionar a janela. Sem
  // isso a pastilha fica presa no modo compacto calculado para a tela anterior.
  observarLargura() {
    if (!this.marksElement || !window.ResizeObserver) return;
    let espera;
    this.observador = new ResizeObserver(() => {
      clearTimeout(espera);
      espera = setTimeout(() => this.ajustarPastilhas(), 120);
    });
    // .fsbar-marks e absoluto com inset:0, entao so acompanha o trilho — mexer
    // nas pastilhas nao muda o tamanho dele e nao realimenta o observador.
    this.observador.observe(this.marksElement);
  }

  readMarcos() {
    const el = this.querySelector("[data-fsbar-config]");
    if (!el) return [];
    try {
      const arr = JSON.parse(el.textContent || "[]");
      return arr
        .filter((m) => m && parseFloat(m.v) > 0)
        .map((m) => ({
          v: parseFloat(m.v),
          label: m.label || "",
          pending: m.pending || "",
          reached: m.reached || "",
        }))
        .sort((a, b) => a.v - b.v);
    } catch (e) {
      return [];
    }
  }

  renderMarks() {
    const n = this.marcos.length;
    const max = this.marcos[n - 1].v;
    const pos = this.marcos.map((m) => (max > 0 ? (m.v / max) * 100 : 0));

    if (!this.marksElement) return;

    const meia = 100 / (2 * n);
    this.classList.toggle(
      "has-tags",
      this.marcos.some((m) => m.label)
    );

    // Valor e etiqueta vao DENTRO da pastilha, em duas linhas. Etiqueta solta
    // abaixo do trilho nao funciona: a do ultimo marco fica em left:100%, sem
    // espaco para shrink-to-fit, e o texto quebra uma letra por linha.
    const pastilhas = this.marcos.map((m, i) => {
      const lado =
        pos[i] < meia ? " is-start" : pos[i] > 100 - meia ? " is-end" : "";
      const etiqueta = m.label
        ? `<span class="fsbar-chip-t">${m.label}</span>`
        : "";
      const cheio = this.moneyCurta(m.v);
      const curto = cheio.replace(/^[^\d]+/, "");
      return `<span class="fsbar-chip${lado}" data-fsbar-v="${m.v}" style="left:${pos[i]}%"><span class="fsbar-chip-v" data-cheio="${cheio}" data-curto="${curto}">${cheio}</span>${etiqueta}</span>`;
    });

    this.marksElement.innerHTML = pastilhas.join("");
    this.ajustarPastilhas();
  }

  // A pastilha nasce do tamanho do conteudo. So encolhe se a MEDICAO mostrar
  // sobreposicao com a vizinha — limitar pelo vao teorico cortava "R$ 499" em
  // "R$ 49..." mesmo havendo espaco livre, porque a vizinha do meio reservava
  // um vao que nao usava.
  ajustarPastilhas() {
    if (!this.marksElement) return;
    const chips = [...this.marksElement.querySelectorAll(".fsbar-chip")];
    if (chips.length < 2) return;
    if (!this.marksElement.getBoundingClientRect().width) return; // drawer fechado

    const passada = () => {
      chips.forEach((c) => (c.style.maxWidth = ""));
      const natural = chips.map((c) => c.getBoundingClientRect().width);
      for (let i = 1; i < chips.length; i++) {
        const a = chips[i - 1].getBoundingClientRect();
        const b = chips[i].getBoundingClientRect();
        const excesso = a.right - b.left + 2;
        if (excesso > 0) {
          chips[i - 1].style.maxWidth =
            Math.max(26, a.width - excesso / 2) + "px";
          chips[i].style.maxWidth = Math.max(26, b.width - excesso / 2) + "px";
        }
      }
      // scrollWidth/clientWidth sao inteiros: um corte de 0,4px passa batido e o
      // "..." aparece assim mesmo. Comparar a largura final com a natural pega o
      // corte no subpixel.
      return chips.some(
        (c, i) => c.getBoundingClientRect().width < natural[i] - 0.5
      );
    };

    // Enquanto sobrar texto cortado, degrada em etapas — melhor um valor menor
    // e inteiro do que "R$ 39..." truncado.
    this.classList.remove("chips-compactas"); // 1. tamanho normal
    this.mostrarMoeda(true);
    if (!passada()) return;
    this.classList.add("chips-compactas"); // 2. fonte menor em TODAS
    if (!passada()) return;
    this.mostrarMoeda(false); // 3. "499" em vez de "R$ 499"
    passada();
  }

  mostrarMoeda(sim) {
    this.marksElement.querySelectorAll(".fsbar-chip-v").forEach((s) => {
      const t = sim ? s.dataset.cheio : s.dataset.curto;
      if (t && s.textContent !== t) s.textContent = t;
    });
  }

  // Duas barras = duas instancias, e cada uma pedia /cart.js por conta propria.
  // Elas disparam no mesmo tick (o tema percorre os wrappers em sequencia), entao
  // quem chega enquanto o pedido esta EM VOO aproveita a mesma resposta. O cache
  // morre assim que a resposta chega — nunca serve carrinho velho.
  static buscarCarrinho() {
    if (!FreeShippingMeter.pedidoEmVoo) {
      FreeShippingMeter.pedidoEmVoo = new Promise((entregar) => {
        Shopify.getCart((cart) => {
          FreeShippingMeter.pedidoEmVoo = null;
          entregar(cart);
        });
      });
    }
    return FreeShippingMeter.pedidoEmVoo;
  }

  initialize() {
    FreeShippingMeter.buscarCarrinho().then((cart) => {
      this.cart = cart;
      this.calculateProgress(cart);
    });
  }

  onCartChange(e) {
    this.initialize();
  }

  money(reais) {
    return Shopify.formatMoney(Math.round(reais * 100), window.money_format);
  }

  // "R$ 199,00" -> "R$ 199" (so quando os centavos sao zero), p/ caber sob a bolinha
  moneyCurta(reais) {
    return this.money(reais).replace(/,00(?!\d)/, "");
  }

  fillTemplate(tpl, marco, total) {
    const falta = Math.max(0, marco.v - total);
    return String(tpl || "")
      .replace(/\{falta\}/g, this.money(falta))
      .replace(/\{meta\}/g, this.money(marco.v))
      .replace(/\{total\}/g, this.money(total));
  }

  calculateProgress(cart) {
    // Bruto (antes de cupom/desconto). Com total_price a barra RECUAVA ao ganhar
    // desconto; o Shopify avalia o frete gratis pelo valor cheio do carrinho.
    let totalPrice = cart.original_total_price;
    if ($("body").hasClass("setup_shipping_delivery")) {
      const giftCardItems = $(
        ".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]"
      );
      if (giftCardItems.length > 0) {
        giftCardItems.each(function () {
          totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
        });
      }
    }
    const cartTotalPrice = parseInt(totalPrice) / 100;
    const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
    const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

    if (this.marcos.length) {
      this.calculateProgressMarcos(cartTotalPriceRounded);
      return;
    }

    let freeShipBar = Math.abs(
      (cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice
    );
    if (freeShipBar >= 100) {
      freeShipBar = 100;
    }

    const text = this.getText(cartTotalPriceFormatted, freeShipBar);
    const classLabel = this.getClassLabel(freeShipBar);

    this.setProgressWidthAndText(freeShipBar, text, classLabel);
  }

  calculateProgressMarcos(total) {
    const max = this.marcos[this.marcos.length - 1].v;
    let freeShipBar = max > 0 ? Math.abs((total * 100) / max) : 0;
    if (freeShipBar >= 100) freeShipBar = 100;

    const reached = this.marcos.filter((m) => total >= m.v);
    const next = this.marcos.find((m) => total < m.v);

    this.freeShippingEligible = reached.length ? 1 : 0;
    this.progressBar.classList.remove("progress-hidden");

    // ACIMA da barra: so o que ainda falta. ABAIXO, na caixa destacada: o que ja
    // ganhou. Com todos os marcos batidos nao falta nada, entao o topo fica vazio
    // e a mensagem final vai para a caixa — o sucesso nunca perde o destaque.
    let text = "";
    let ganho = "";
    if (next) {
      text = this.fillTemplate(next.pending, next, total);
      if (reached.length) {
        const ultimo = reached[reached.length - 1];
        ganho = this.fillTemplate(ultimo.reached, ultimo, total);
      }
    } else {
      const last = this.marcos[this.marcos.length - 1];
      ganho = this.fillTemplate(last.reached, last, total);
    }

    if (this.wonElement) this.wonElement.innerHTML = ganho;

    if (this.marksElement) {
      this.marksElement.querySelectorAll("[data-fsbar-v]").forEach((el) => {
        el.classList.toggle("is-reached", total >= parseFloat(el.dataset.fsbarV));
      });
      this.ajustarPastilhas();
    }

    this.setProgressWidthAndText(
      freeShipBar,
      text ? `<span>${text}</span>` : "",
      this.getClassLabel(freeShipBar)
    );
  }

  getText(cartTotalPrice, freeShipBar) {
    let text;

    if (cartTotalPrice == 0) {
      this.progressBar.classList.add("progress-hidden");
      text =
        "<span>" +
        FreeShippingMeter.freeShippingText +
        " " +
        Shopify.formatMoney(
          FreeShippingMeter.freeshipPrice * 100,
          window.money_format
        ) +
        "!</span>";
    } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
      this.progressBar.classList.remove("progress-hidden");
      this.freeShippingEligible = 1;
      text = FreeShippingMeter.freeShippingText1;
    } else {
      this.progressBar.classList.remove("progress-hidden");
      const remainingPrice = Math.abs(
        FreeShippingMeter.freeshipPrice - cartTotalPrice
      );
      text =
        "<span>" +
        FreeShippingMeter.freeShippingText2 +
        " </span>" +
        Shopify.formatMoney(remainingPrice * 100, window.money_format) +
        "<span> " +
        FreeShippingMeter.freeShippingText3 +
        ' </span><span class="text">' +
        FreeShippingMeter.freeShippingText4 +
        "</span>";
      this.shipVal = FreeShippingMeter.texts.free_shipping_2;
    }

    return text;
  }

  getClassLabel(freeShipBar) {
    let classLabel;

    if (freeShipBar === 0) {
      classLabel = "none";
    } else if (freeShipBar <= 30) {
      classLabel = FreeShippingMeter.classLabel1;
    } else if (freeShipBar <= 60) {
      classLabel = FreeShippingMeter.classLabel2;
    } else if (freeShipBar < 100) {
      classLabel = FreeShippingMeter.classLabel3;
    } else {
      classLabel = "progress-free";
    }

    return classLabel;
  }

  resetProgressClass(classLabel) {
    this.progressBar.classList.remove("progress-30");
    this.progressBar.classList.remove("progress-60");
    this.progressBar.classList.remove("progress-100");
    this.progressBar.classList.remove("progress-free");

    this.progressBar.classList.add(classLabel);
  }

  setProgressWidthAndText(freeShipBar, text, classLabel) {
    setTimeout(() => {
      this.resetProgressClass(classLabel);

      this.progressMeter.style.width = `${freeShipBar}%`;
      if (this.textEnabled) {
        const textWrapper = (this.progressMeter.querySelector(
          ".text"
        ).innerHTML = `${freeShipBar.toFixed(2)}%`);
      }

      this.messageElement.innerHTML = text;

      if ($(".dropdown-item[data-currency]").length) {
        if (
          (window.show_multiple_currencies &&
            typeof Currency != "undefined" &&
            Currency.currentCurrency != shopCurrency) ||
          window.show_auto_currency
        ) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
      }
    }, 400);
  }
}

window.addEventListener("load", () => {
  if (!customElements.get("free-shipping-component")) customElements.define("free-shipping-component", FreeShippingMeter);
});
